<template>
  <div>
    <!-- page-wrapper Start-->
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img :src="ImageEndpoint + CompanyLogo" class="img-fluid for-light" v-if="CompanyLogo" style='height: 50px;'>
                  	<img src="@/assets/images/logo.png" class="img-fluid for-light" v-if="!CompanyLogo" style='height: 50px;'>
                 <!--- <img
                    src="@/assets/images/logo.png"
                    class="img-fluid for-light"
                    style="height: 50px"
                  />-->
                </a>
              </div>
              <div class="login-main">
                <b-card no-body>
                  <b-tabs pills vertical>
                    <b-tab active>
                      <b-card-text>
                        <form class="theme-form">
                          <h4>Sign in to account</h4>
                          <p>Enter your email & password to login</p>
                          <div class="form-group">
                            <label class="col-form-label">Email Address</label>
                            <input
                              v-model="email"
                              class="form-control"
                              type="email"
                              required=""
                              :class="{
                                'is-invalid': submitted && !email,
                              }"
                            />
                            <div
                              v-show="submitted && !email"
                              class="invalid-feedback"
                            >
                              Email is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="col-form-label">Password </label>
                            <input
                              v-model="password"
                              autocomplete=""
                              class="form-control"
                              :type="type"
                              name="login[password]"
                              required=""
                              :class="{
                                'is-invalid': submitted && !email,
                              }"
                            />
                            <div
                              v-show="submitted && !password"
                              class="invalid-feedback"
                            >
                              Password is required
                            </div>
                            <div class="show-hide" @click="showPassword">
                              <span class="show"></span>
                            </div>
                          </div>
                          <div class="form-group mb-0">
                            <div class="checkbox p-0">
                              <input id="checkbox1" type="checkbox" v-model="is_remember" />
                              <label class="text-muted" for="checkbox1"
                                >Remember me</label
                              >
                              <span class="f-right">
                                <a href="javascript:void(0);"></a>
                                <router-link
                                to="/auth/forgot-password"
                              >
                                <span>forgot password?</span>
                              </router-link>
                              </span>
                            </div>
                            <button
                              class="btn btn-primary btn-block"
                              type="button"
                              @click="UserLogin"
                            >
                              Login
                            </button>
                          </div>
                        </form>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
              <div class="col-sm-12 text-center" v-if="CompanyLogo">
                <p class="m-b-5">Powered by</p>
                <img
                  src="@/assets/images/logo.png"
                  class="img-fluid for-light1"
                  style="width: 100px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- latest jquery-->
  </div>
</template>

<script>
  import firebase from "firebase";
  import Userauth from "../auth/js/index";
  import Endpoints from "@/config/ApiEndpoints.js";
  import Swal from "sweetalert2";

  export default {
    name: "login",
    data() {
      return {
        CompanyLogo: "",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        type: "password",
        email: "",
        password: "",
        username: "",
        is_remember: "",
        passwordjwt: "",
        submitted: false,
      };
    },
    computed: {
      // JWT authentication
      
      
      loggingIn() {
        return this.$store.state.authentication.status.loggingIn;
      },
    },
    created() {
      // reset login status for JWT
      this.$store.dispatch("authentication/logout");
      sessionStorage.removeItem("DocumentCategories");
      sessionStorage.removeItem("DocumentVehicles");
      sessionStorage.removeItem("DocumentAssets");
      sessionStorage.removeItem("DriverColor");
    },
    mounted() {
      var Company = JSON.parse(localStorage.getItem("Company"));
      if (Company && Company.logo) {
        this.CompanyLogo = Company.logo;
      }
      if(localStorage.getItem('rememberData')){
        var remeber = JSON.parse(localStorage.getItem('rememberData'));
        this.email = remeber.email;
        this.is_remember = true;
      }
    },
    methods: {
      showPassword: function () {
        if (this.type === "password") {
          this.type = "text";
        } else {
          this.type = "password";
        }
      },
      UserLogin: function () {
        this.submitted = true;
        if (this.email != "" && this.password != "") {
          var obj = { email: this.email, password: this.password };
          localStorage.removeItem("rememberData");
          if(this.is_remember){
            localStorage.setItem("rememberData", JSON.stringify({ email: this.email}));
          }
          Swal.fire({
            title: "Checking...",
            text: "Please wait...",
            imageUrl: require("../assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          axios
            .post(Endpoints.User.Login, obj)
            .then((Response) => {
              Swal.close();
              if (Response?.data?.success === true) {
                if(Response.data.type == "2FA"){
                  localStorage.setItem("email2fa", Response.data.email);
                  localStorage.setItem("Company",JSON.stringify(Response.data.Company));
                  this.$router.replace("/auth/login/step-2");
                }else{
                  localStorage.setItem("token", Response.data.token);
                  localStorage.setItem(
                    "User",
                    JSON.stringify(Response.data.User)
                  );
                  localStorage.setItem(
                    "PasswordReset",
                    Response.data.User['is_password_reset']
                  );
                  localStorage.setItem(
                    "Company",
                    JSON.stringify(Response.data.Company)
                  );
                  localStorage.setItem(
                    "FleetSubscription",
                    JSON.stringify(Response.data.FleetSubscription)
                  );

                  // Update the value
                  localStorage.setItem(
                    "AccountPermissions",
                    JSON.stringify(Response.data.AccountPermissions)
                  );
                  // Update the value
                  localStorage.setItem(
                    "permissions",
                    JSON.stringify(Response.data.permissions)
                  );
                  window.pbx_SiteTitle = Response.data.Company.name;
                  Userauth.localLogin(Response.data);
                    
                  this.$router.replace("/");
                }


                //this.$router.push('/home');
                if (localStorage.getItem("Classes")) {
                  localStorage.removeItem("Classes");
                }
              } else {
                this.$toasted.show(Response?.data?.message || "Something went wrong", {
                  theme: "bubble",
                  position: "top-center",
                  type: "error",
                  duration: 2000,
                });
              }
            })
            .catch((error) => {
              this.$toasted.show(error, {
                theme: "bubble",
                position: "top-center",
                type: "error",
                duration: 2000,
              });
            });
        } else {
          this.$toasted.show("Please enter email and password", {
            theme: "bubble",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
        }
      },
    },
  };
</script>
